import { Button } from '~components/generic/editor/Button/Button';
import { ButtonGroup } from '~components/generic/editor/ButtonGroup/ButtonGroup';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, CloseIcon, DeleteIcon, PenIcon } from '~components/icons';
import useLabels from '~hooks/useLabels';
import { ModuleEditMenu } from './ModuleEditMenu/ModuleEditMenu';

type ColorShadeEditOverlayProps = {
  isEditing: boolean;
  moduleTitle: string;
  moduleIcon?: string;
  canEdit: boolean;
  canMoveUp: boolean;
  canMoveDown: boolean;
  onStopEdit: () => void;
  onStartEdit: () => void;
  onSaveEdit: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onDelete: () => void;
};

export const ColorShadeEditOverlay = ({
  isEditing,
  moduleTitle,
  canEdit,
  canMoveUp,
  canMoveDown,
  onStopEdit,
  onStartEdit,
  onSaveEdit,
  onMoveUp,
  onMoveDown,
  onDelete,
}: ColorShadeEditOverlayProps) => {
  const {
    msgEditModuleHint,
    msgMoveUpModuleHint,
    msgMoveDownModuleHint,
    msgCancelModuleHint,
    msgDeleteModuleHint,
    msgSaveModuleHint,
  } = useLabels([
    'msgEditModuleHint',
    'msgMoveUpModuleHint',
    'msgMoveDownModuleHint',
    'msgCancelModuleHint',
    'msgDeleteModuleHint',
    'msgSaveModuleHint',
  ]);
  const showEdit = !isEditing && canEdit;
  const showMoveDown = !isEditing && canMoveDown;
  const showMoveUp = !isEditing && canMoveUp;
  const showCancelDeleteSave = isEditing;

  return (
    <ModuleEditMenu show={isEditing} title={moduleTitle}>
      <ButtonGroup vertical={showCancelDeleteSave} small={showMoveUp || showMoveDown}>
        {showEdit && <Button title={msgEditModuleHint} icon={<PenIcon />} onClick={onStartEdit} />}
        {showMoveUp && <Button title={msgMoveUpModuleHint} onClick={onMoveUp} icon={<ArrowLeftIcon />} />}
        {showMoveDown && <Button title={msgMoveDownModuleHint} onClick={onMoveDown} icon={<ArrowRightIcon />} />}
        {showCancelDeleteSave && (
          <>
            <Button title={msgCancelModuleHint} onClick={onStopEdit} icon={<CloseIcon />} />
            <Button title={msgDeleteModuleHint} onClick={onDelete} icon={<DeleteIcon />} />
            <Button title={msgSaveModuleHint} onClick={onSaveEdit} icon={<CheckIcon />} />
          </>
        )}
      </ButtonGroup>
    </ModuleEditMenu>
  );
};
